const DOJO_ACTION = {
    SET_EXERCISE_DETAILS: 'SET_EXERCISE_DETAILS',
    SET_BELT_TEST_DETAILS: 'SET_BELT_TEST_DETAILS',
    SET_LOCAL_USER_SOLUTION_DATA: 'SET_LOCAL_USER_SOLUTION_DATA',
    UPDATE_CHALLENGE_COUNTER: 'UPDATE_CHALLENGE_COUNTER',
    SET_REM_TIME: 'SET_REM_TIME',
    SET_MODE: 'SET_MODE',
    SET_OTP_VALIDITY: 'SET_OTP_VALIDITY',
    SET_BELT_TEST_STATE: 'SET_BELT_TEST_STATE',
    SET_WORKOUT_LIST: 'SET_WORKOUT_LIST',
    SET_CURRENT_WORKOUT: 'SET_CURRENT_WORKOUT',
    DECREMENT_REM_TIME: 'DECREMENT_REM_TIME',
    SET_BGM_CURRENT_TIME: 'SET_BGM_CURRENT_TIME',
    SET_QUESTION_SOLVED: 'SET_QUESTION_SOLVED',
    SET_HINTS: 'SET_HINTS',
}

export default DOJO_ACTION
